

import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import API from "./axiosInstance";
import "./AdminPanel.css";

function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchEmail, setSearchEmail] = useState("");
  const [searchOrderId, setSearchOrderId] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const adminToken = localStorage.getItem("adminToken");
    if (!adminToken) {
      navigate("/admin/login");
      return;
    }
    fetchOrders();
  }, [navigate]);

  const fetchOrders = async () => {
    try {
      const res = await API.get("/orders");
      setOrders(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (order, status) => {
    try {
      await API.put(`/orders/${order.id}/status`, {
        status,
        courierName: order.courierName || "",
        trackingId: order.trackingId || "",
      });

      setOrders((prev) =>
        prev.map((o) =>
          o.id === order.id ? { ...o, status } : o
        )
      );

      alert("Order updated");
    } catch (err) {
      alert("Update failed");
    }
  };

  const updateField = (id, field, value) => {
    setOrders((prev) =>
      prev.map((o) =>
        o.id === id ? { ...o, [field]: value } : o
      )
    );
  };

  const filteredOrders = orders.filter((o) => {
    return (
      o.email.toLowerCase().includes(searchEmail.toLowerCase()) &&
      o.id.toString().includes(searchOrderId)
    );
  });

  if (loading) return <p>Loading...</p>;

  return (
    <div className="admin-container">
      <div className="main-content">

        <button className="back-btn" onClick={() => navigate(-1)}>
          ⬅ Back
        </button>

        <h2>📦 Admin Orders</h2>

        {/* 🔍 Search */}
        <div className="search-row">
          <input
            placeholder="Search Email"
            value={searchEmail}
            onChange={(e) => setSearchEmail(e.target.value)}
          />
          <input
            placeholder="Order ID"
            value={searchOrderId}
            onChange={(e) => setSearchOrderId(e.target.value)}
          />
        </div>

        {filteredOrders.map((order) => (
          <div key={order.id} className="order-card">

            {/* Header */}
            <div className="order-head">
              <div>
                <strong>#{order.id}</strong> — {order.email}
              </div>
              <div>₹{order.totalAmount}</div>
            </div>

            {/* Products */}
            <div className="product-row">
              {order.items.map((item, i) => (
                <img
                  key={i}
                  src={item.images?.[0] || "https://via.placeholder.com/80"}
                  alt=""
                />
              ))}
            </div>

            {/* Address */}
            <p className="address">
              {order.name}, {order.address}, {order.city} – {order.pincode}, {order.state} <br />
              📞 {order.mobile}
            </p>

            {/* Status */}
            <select
              value={order.status}
              onChange={(e) =>
                handleStatusChange(order, e.target.value)
              }
            >
              <option>Pending</option>
              <option>Processing</option>
              <option>Shipped</option>
              <option>Completed</option>
              <option>Cancelled</option>
            </select>

            {/* 🚚 Courier Details */}
            {order.status === "Shipped" && (
              <div className="shipping-box">
                <input
                  placeholder="Courier Name"
                  value={order.courierName || ""}
                  onChange={(e) =>
                    updateField(order.id, "courierName", e.target.value)
                  }
                />
                <input
                  placeholder="Tracking ID"
                  value={order.trackingId || ""}
                  onChange={(e) =>
                    updateField(order.id, "trackingId", e.target.value)
                  }
                />
              </div>
            )}

          </div>
        ))}
      </div>
    </div>
  );
}

export default AdminOrders;
